import React, { useState } from 'react'
import moment from 'moment';
import 'moment/locale/th';
import useTranslations from 'i18n/useTranslations';
import helper from 'services/helper';
import _, { toInteger } from 'lodash';

const PointInfoTier = ({ point = 0, expiredPoint = 0, expiredDate, profile = {}, tierConfig = [] }) => {
    const { t, lang } = useTranslations();
    const [isConditionOpened, setIsConditionOpened] = useState(false);
    // หากไม่มี expiredDate ให้ใช้วันที่ปัจจุบัน
    const dateToUse = expiredDate ? expiredDate : moment().toISOString();

    // Format the date and add 543 to the year to convert to Buddhist year
    let formattedDate = ''
    if( lang === 'th'){
        formattedDate = moment(dateToUse).locale('th').format('DD MMMM ') + (parseInt(moment(dateToUse).locale('th').format('YYYY')) + 543);
    }else{
        formattedDate = moment(dateToUse).locale('en').format('DD MMMM ') + (parseInt(moment(dateToUse).locale('en').format('YYYY')));
    }

    const toggleCondition = () => {
        setIsConditionOpened(!isConditionOpened);
    }

    const findTierByName = (name = '', option = []) => {
        const OPTION = _.cloneDeep(option)
        let ans = OPTION.find(item => `${item.name}`.toLowerCase() === `${name}`.toLowerCase()) ?? {}
        console.log("🚀 ~ Sliver ~ ans:", ans)
        return ans
    }


    const numWithCommas = helper.FN.toNumberWithCommas
    let totalSpending = profile?.totalSpending
    let pointToNextTier = profile?.pointToNextTier
    let tierMinTotal = profile?.tierMinTotal
    let nextTier = profile?.nextTier
    let tierMaxTotal = profile?.tierMaxTotal
    let rank = profile?.rank ? `${profile?.rank}`.toLowerCase() : 'basic'
    const TotalSpending = numWithCommas(totalSpending ? toInteger(totalSpending) : 0)
    const TotalSpendingFull = numWithCommas(totalSpending ? totalSpending : '0.00')
    
    const progressWidth = helper.FN.calPercen(totalSpending, tierMaxTotal)

    const BASIC_DATA = findTierByName('basic', tierConfig)
    const SILVER_DATA = findTierByName('silver', tierConfig)
    const GOLD_DATA = findTierByName('gold', tierConfig)
    const PLATINUM_DATA = findTierByName('platinum', tierConfig)

    if (false) {
        return (
            <>
            <section id="pPoint">
                <div className="bPoint">
                    <div className="bTop">
                        
                        <h3 style={{ fontSize: lang === 'th' ? 18 : '' }}><i></i> <span>{t.profile.pointCollection}</span></h3>
                        <p><span>{point ? point : 0}</span> {t.profile.points}</p>
                    </div>
                    {expiredDate ? <div className="bBottom">
                        <p>{expiredPoint} {t.profile.expired} {formattedDate}</p>
                    </div> : ""
                    }
                </div>
            </section>
            <div className="bPoint">
                
                <div className="bBtn">
                    <a href={'/customer-qr'} className="btn" style={{ textTransform: 'none' }}><i></i>{t.profile.collection}</a>
                    <a href={'/history-point'} className='btnHistory' style={{ fontSize: '16px' }}><i></i>{t.pointtotier.profilePointHistory}</a>
                </div>
            </div>
        </>
        )
    }

    if (profile?.rank ){
    <h3 style={{ fontSize: lang === 'th' ? 18 : '' }}><i></i> <span>{t.profile.pointCollection}</span></h3>
    // <p><span>{point ? point : 0}</span> {t.profile.points}</p>
    return (
        <>
            <div className="bPoint">
                <div className="bGroup">
                    {/* <!-- เปลี่ยน Tier ที่  "data-tier" : basic : silvere : gold : platinum --> */}
                    <div className="bMemberCard" data-tier={rank}>
                    {/* <!-- เปลี่ยน Tier ที่  "data-tier" : basic : silver : gold : platinum --> */}
                    <span data-tier={rank}></span>
                    <div className="bTop">
                        <h3><span>{t.pointtotier.totalPoint}</span><b>{point ? numWithCommas(point) : 0}</b> {t.profile.points}</h3>
                        <p>{t.pointtotier.spending}</p>
                    </div>
                    <div className="bProgressBar">
                        <div className="bStatus" style={{ width: `${progressWidth}%` }}></div>
                        <p>{TotalSpendingFull} / {nextTier === null ? numWithCommas(Number(tierMinTotal)) : numWithCommas(toInteger(tierMaxTotal))} {t.pointtotier.currency}</p>
                    </div>
                    {
                        expiredDate 
                        ? (
                            <div className="bBottom">
                                <p>{numWithCommas(Number(`${expiredPoint}`))} {t.profile.expired} {formattedDate}</p>
                            </div> 
                        )
                        : <></>
                    }
                    </div>
                        {/* <p>ยอดสะสมที่ท่านได้รับในวันนี้จะมีอายุ 1 ปี นับจากวันที่ได้รับ</p> */}
                        <p>{t.pointtotier.expiredCondition}</p>
                        <div className="bAccord">
                            <div className={`btnAccord ${isConditionOpened ? 'opened' : ''}`} onClick={toggleCondition}>{t.pointtotier.tierCondition}</div>
                            <div className="contentAccord">
                                {isConditionOpened && (
                                    <div className="bConditionTier">
                                        <article>
                                            <div>
                                                <span data-tier="basic"></span>
                                                <p>
                                                    {t.pointtotier.started}
                                                </p>
                                            </div>
                                            <span><b>{BASIC_DATA.minTotal ? numWithCommas(Number(`${BASIC_DATA.minTotal}`)): 0 } - {BASIC_DATA.maxTotal ? numWithCommas(toInteger(`${BASIC_DATA.maxTotal}`)): 0 }</b> {t.pointtotier.currency}</span>
                                        </article>
                                        <article>
                                            <div>
                                                <span data-tier="silver"></span>
                                                <p>
                                                    {t.pointtotier.accumulated}
                                                </p>
                                            </div>
                                            <span><b>{SILVER_DATA.minTotal ? numWithCommas(Number(`${SILVER_DATA.minTotal}`)): 0 }</b> {t.pointtotier.currency}</span>
                                        </article>
                                        <article>
                                            <div>
                                                <span data-tier="gold"></span>
                                                <p>
                                                    {t.pointtotier.accumulated}
                                                </p>
                                            </div>
                                            <span><b>{GOLD_DATA.minTotal ? numWithCommas(Number(`${GOLD_DATA.minTotal}`)): 0 }</b> {t.pointtotier.currency}</span>
                                        </article>
                                        <article>
                                            <div>
                                                <span data-tier="platinum"></span>
                                                <p>
                                                    {t.pointtotier.accumulated}
                                                </p>
                                            </div>
                                            <span><b>{PLATINUM_DATA.minTotal ? numWithCommas(Number(`${PLATINUM_DATA.minTotal}`)): 0 }</b> {t.pointtotier.currency}{t.pointtotier.lasttierStrAddons}</span>
                                        </article>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                <div className="bBtn">
                    <a href={'/customer-qr'} className="btn" style={{ textTransform: 'none' }}><i></i>{t.profile.collection}</a>
                    <a href={'/history-point'} className='btnHistory' style={{ fontSize: '16px' }}><i></i>{t.pointtotier.profilePointHistory}</a>
                </div>
            </div>
        </>
        
    )
    }
}

export default PointInfoTier